<template>
  <div class="DateDropDownSelect" :class="getStyle()">
    <div class="dis-block">
      <!-- 年 月 季度 -->
      <el-select
        v-model="selectValve"
        :style="{ width: selectWidth + 'px' }"
        class="drop-down-select"
        placeholder="请选择"
      >
        <el-option
          v-for="itemc in data"
          :key="itemc.label"
          @click.native.prevent="handleSelect(itemc.value)"
          :label="itemc.label"
          :value="itemc"
        />
      </el-select>
      <!-- 根据 showSecondSelect 状态决定是否显示第二个下拉框 -->
      <el-select
        v-if="showSecondSelect"
        v-model="secondSelectValve"
        :style="{ width: selectWidth + 'px' }"
        class="drop-down-select"
        placeholder="请选择"
      >
        <el-option
          v-for="item in selectValve.children"
          :key="item.label"
          @click.native.prevent="handleSecondSelect(item.value)"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'DateDropDownSelect',
  props: {
    textSelectData: Array,
    selectApi: String,
  },
  data() {
    return {
      year: '',
      month: '',
      day: '',
      booDecideTitle: false,
      selectValve: '',
      selectWidth: 60,
      selectThird: '',
      selectChildData: {},
      childData: false,
      childThirdData: false,
      childData1: {},
      watchNewm: '',
      watchNewy: '',
      watchMootm: '',
      currentChartsList: null,
      days: [],
      data: [
        {
          label: '2025',
          value: '2025',
          modelValue: '2025',
        },
        {
          label: '2024',
          value: '2024',
          modelValue: '2024',
        },
        {
          label: '2023',
          value: '2023',
          modelValue: '2023',
        },
        {
          label: '2022',
          value: '2022',
          modelValue: '2022',
        },
      ],
      // 新增变量，用于控制第二个下拉框的显示
      showSecondSelect: false,
      secondSelectValve: '',
    };
  },
  computed: {
    ...mapState({
      componentName: state => state.ProjectInfo.CurrentScene.Charts,
      currentECharts: state => state.ProjectInfo.CurrentScene.Charts,
    }),
  },
  mounted() {
    if (this.selectApi.currenEntry === 'staticData') {
      // 判断未连接api数据
      this.selectValve = this.data[0];
    } else {
      this.selectValve = this.textSelectData[0];
      this.data = this.textSelectData;
      // 根据 modelValue 的值决定是否显示第二个下拉框
      console.log(this.textSelectData, '34534534535345');

      if (this.selectValve.modelValue === 'festival') {
        this.showSecondSelect = true;
        // 初始化第二个下拉框的值为 children 里的第一个值
        if (this.selectValve.children && this.selectValve.children.length > 0) {
          this.secondSelectValve = this.selectValve.children[0].value;
        }
      } else if (this.selectValve.modelValue === 'DowTrue') {
        this.showSecondSelect = false;
      }
    }
  },
  methods: {
    getStyle() {
      let style = {};
      switch (this.componentName) {
        case 'V1Style':
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style['V5Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },

    handleSelect(val) {
      this.$emit('textChange', val);
      if (/[\u4e00-\u9fa5]/g.test(val)) {
        function countChineseAndEnglish(str) {
          const chineseRegex = /[\u4e00-\u9fa5]/g; // 匹配中文字符的正则
          let chineseCount = (str.match(chineseRegex) || []).length;
          return chineseCount;
        }
        const result = countChineseAndEnglish(val);
        if (result > 4) {
          return (this.selectWidth = 154);
        } else {
          return (this.selectWidth = 60);
        }
      }
    },
    handleSecondSelect(val) {
      this.$emit('textChange', val);
    },
  },
};
</script>

<style lang="scss" scoped>
.DateDropDownSelect {
  position: relative;
}

.drop-down-select {
  margin-left: 4px;
}

:deep().drop-down-select .el-input__inner {
  /* width: 72px; */
  height: 22px;
  line-height: 22px;
  padding-left: 10px;
  padding-right: 20px;
  background: none;
  border: 1px solid #148cdb;
  color: #03b8ca;
  font-size: 12px;
  position: relative;
}

:deep().el-input--small .el-input__icon {
  line-height: 22px;
}

:deep().el-input__suffix {
  right: 0;
  top: -8px;

  .el-input__suffix-inner {
    margin: 0;
  }
}

:deep().drop-down-select {
  &:nth-child(n + 2) {
    .el-input__inner {
      width: 60px;
    }
  }
}

:deep().el-select__popper.el-popper {
  background: none !important;
}

:deep().el-icon-arrow-up:before {
  color: #00f4fd;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 94px;
    height: 24px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
}
@media screen and (min-width: 3300px) {
  :deep().el-input__suffix {
    top: -4px !important;
  }
  :deep().drop-down-select .el-input__inner {
    height: 33px !important;

    font-size: 18px !important;
  }
}
</style>
